const prefix = 'FactNegotiationCase';

export enum FactNegotiationCaseMeasure {
  AVG_TIME_CREATED_SENT = `${prefix}.avgTimeFromCreatedToSent`,
  AVG_TIME_SENT_OPENED = `${prefix}.avgTimeFromSentToOpened`,
  AVG_TIME_SENT_AGREEMENT = `${prefix}.avgTimeFromSentToAgreement`,
  AVG_TIME_OPENED_AGREEMENT = `${prefix}.avgTimeFromOpenedToAgreement`,
  AVG_TIME_NEGOTIATED_AWARDED = `${prefix}.avgTimeFromAgreementToAwarded`,
  MIN_TIME_CREATED_SENT = `${prefix}.minTimeFromCreatedToSent`,
  MIN_TIME_SENT_OPENED = `${prefix}.minTimeFromSentToOpened`,
  MIN_TIME_SENT_AGREEMENT = `${prefix}.minTimeFromSentToAgreement`,
  MIN_TIME_OPENED_AGREEMENT = `${prefix}.minTimeFromOpenedToAgreement`,
  MIN_TIME_NEGOTIATED_AWARDED = `${prefix}.minTimeFromAgreementToAwarded`,
  MAX_TIME_CREATED_SENT = `${prefix}.maxTimeFromCreatedToSent`,
  MAX_TIME_SENT_OPENED = `${prefix}.maxTimeFromSentToOpened`,
  MAX_TIME_SENT_AGREEMENT = `${prefix}.maxTimeFromSentToAgreement`,
  MAX_TIME_OPENED_AGREEMENT = `${prefix}.maxTimeFromOpenedToAgreement`,
  MAX_TIME_NEGOTIATED_AWARDED = `${prefix}.maxTimeFromAgreementToAwarded`,

  COUNT = `${prefix}.count`,
}

export enum FactNegotiationCaseDimension {
  CREATED_AT = `${prefix}.createdAt`,
  NEGOTIATION_CASE_ID = `${prefix}.negotiationCaseId`,
  TIME_TO_CANCELLED_BY_SYSTEM = `${prefix}.timeToCancelledBySystem`,
  TIME_TO_CANCELLED_BY_USER = `${prefix}.timeToCancelledByUser`,
}
